import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { supergatorActions } from '@/redux/modules';

const useSupergatorSso = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector(state => state.supergator.sso);

  const redirectToSupergator = useCallback((options) => {
    const payload = typeof options?.redirectPath === 'string'
      ? { redirectPath: options.redirectPath }
      : {};
    dispatch(supergatorActions.sso.request(payload));
  }, [dispatch]);

  return { redirectToSupergator, loading };
};

export default useSupergatorSso;
